let locks = 0;
let restore;

export function lockDialogScroll() {
  if (locks++ === 0) {
    const body = document.body;
    const y = window.scrollY;
    const x = window.scrollX;
    const keys = ["position", "top", "left", "width", "overflow"];
    const previous = keys.map((key) => body.style[key]);
    Object.assign(body.style, {
      position: "fixed",
      top: `${-y}px`,
      left: `${-x}px`,
      width: "100%",
      overflow: "hidden",
    });
    restore = () => {
      keys.forEach((key, index) => {
        body.style[key] = previous[index];
      });
      window.scrollTo(x, y);
    };
  }
  let released = false;
  return () => {
    if (released) return;
    released = true;
    if (--locks === 0) restore();
  };
}
